<template>
  <v-card
    color="transparent"
    data-aos="fade"
    flat
    v-if="event"
  >
    <v-hover
      v-if="event.image"
      :disabled="!editable"
    >
      <template v-slot:default="{ hover }">
        <v-parallax
          class="mb-5"
          :src="event.image.url">
          <v-container>
            <v-card
              class="px-2"
              color="transparent"
              flat
            >
              <v-card-title
                class="event-title py-2 text-center justify-center"
                :style="{color: event.titleColor}"
              >{{event.title}}</v-card-title>
            </v-card>
            <v-card
              color="transparent"
              flat
              class="px-2"
              v-for="(subtitle, index) in event.subtitles"
              :key="index"
            >
              <v-card-title
                class="event-title-sm py-2 text-center justify-center"
                :style="{color: event.titleColor}"
              >{{subtitle}}</v-card-title>

            </v-card>
            <v-overlay
              absolute
              opacity="0.2"
              v-if="hover"
            >
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    fab
                    @click="editTitle"
                    v-bind="attrs"
                    v-on="on"
                  >
                    <v-icon>mdi-format-title</v-icon>
                  </v-btn>
                </template>
                <span>Title</span>
              </v-tooltip>

              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    fab
                    @click="onEventAction('image')"
                    v-bind="attrs"
                    v-on="on"
                  >
                    <v-icon>mdi-image-edit</v-icon>
                  </v-btn>
                </template>
                <span>Images</span>
              </v-tooltip>
            </v-overlay>
          </v-container>
        </v-parallax>
      </template>
    </v-hover>
    <slot name="description"></slot>
    <template v-if="event.sections.length">
      <!-- <v-hover
        v-for="(section, index) in event.sections" :key="index"
        v-slot="{ hover }"
        :disabled="true"
      > -->
      <v-hover
        v-for="(section, index) in event.sections" :key="index"
        v-slot="{ hover }"
        :disabled="!editable"
      >
        <v-card flat color="transparent" class="mb-3">
          <template v-if="!section.profiles">
            <event-section
              :editable="hover"
              :header="section.header"
              :headerColor="section.headerColor"
              :index="index"
              :link="section.link"
              :linkText="section.linkText"
              :linkColor="section.linkColor"
              :section="section"
              @action="onAction"
            >
              <v-card
                color="transparent"
                flat
                v-html="section.content">
              </v-card>
            </event-section>
          </template>
          <template v-if="section.profiles">
            <event-profiles
              :editable="hover"
              :index="index"
              :section="section"
              @action="onAction"
            ></event-profiles>
          </template>
        </v-card>
      </v-hover>
    </template>
    <slot name="footer"></slot>
  </v-card>
</template>

<script>
import EventProfiles from '@/components/EventProfiles'
import EventSection from '@/components/EventSection'
import MetaInfoBuilder from '@/utils/social'
import {
  VBtn,
  VCard,
  VCardTitle,
  VContainer,
  VHover,
  VIcon,
  VOverlay,
  VParallax,
  VTooltip,
} from 'vuetify/lib'

export default {
  components: {
    EventProfiles,
    EventSection,
    VBtn,
    VCard,
    VCardTitle,
    VContainer,
    VHover,
    VIcon,
    VOverlay,
    VParallax,
    VTooltip,
  },
  data: () => ({
    tags: ['one', 'two'],
  }),
  metaInfo() {
    if (this.event) {
      return new MetaInfoBuilder()
        .description(this.event.description)
        .image(this.event.image.url)
        .title(this.event.title)
        .build()
    }
  },
  methods: {
    editTitle() {
      this.$emit('title')
    },
    onAction(action) {
      this.$emit('sectionAction', action)
    },
    onEventAction(action) {
      this.$emit('eventAction', action)
    },
    onSearchTags() {}
  },
  props: {
    editable: {
      default: false,
      type: Boolean,
    },
    event: Object,
    subtitles: Array,
  }
}
</script>

<style lang="scss" scoped>
.editable {
  // border: 1px black solid;
  background: rgba($color: #000000, $alpha: .5) !important;
}

.event-title {
  color: white;
  font-size: 40px !important;
  // font-weight: bold;
  // text-shadow: 0 0 5px black;
  // text-transform: uppercase;
  word-break: normal;
  font-family: 'Nanum Myeongjo', serif !important;
  line-height: 50px;
}

.event-title-sm {
  color: white;
  font-size: 28px !important;
  // text-shadow: 0 0 5px black;
  text-transform: uppercase;
  word-break: normal;
}
</style>
